"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
require("jquery.easing/jquery.easing");
require("jquery-match-height");
(0, jquery_1.default)(document).ready(function () {
    btnScroll.init();
    // リサイズ
    var currentWidth = window.innerWidth;
    var currentHeight = window.innerHeight;
    window.addEventListener("resize", function () {
        if (currentWidth !== window.innerWidth || currentHeight !== window.innerHeight) {
        }
        else {
            return false;
        }
        currentWidth = window.innerWidth;
        currentHeight = window.innerHeight;
    }, false);
});
(0, jquery_1.default)(window).on("load", function () {
    home.loaded();
});
(0, jquery_1.default)(window).bind("scroll", function () { });
(0, jquery_1.default)("body").bind("touchmove", function () { });
var win = {
    w: function () {
        return document.body.clientWidth;
    },
    h: function () {
        return document.documentElement.clientHeight;
    },
    st: function () {
        return window.scrollY;
    },
};
var isUser = {
    type: function (className) {
        if ((0, jquery_1.default)("body").hasClass(className)) {
            return true;
        }
        else {
            return false;
        }
    },
};
var btnScroll = {
    t: (0, jquery_1.default)(".js-scroll"),
    init: function () {
        btnScroll.t.on("click", function (event) {
            var hash = (0, jquery_1.default)(event.currentTarget).attr("href");
            if (hash !== undefined) {
                var target = (0, jquery_1.default)(hash.replace("#", "#_"));
                var targetOffset = target.offset();
                targetOffset !== undefined && (0, jquery_1.default)("html, body").animate({ scrollTop: targetOffset.top }, 500, "easeInOutExpo");
            }
            return false;
        });
    },
};
var home = {
    fixedBtn: (0, jquery_1.default)(".lp-fixedBtn"),
    init: function () {
        (0, jquery_1.default)(".js-tglBtn").on("click", function (event) {
            if (!(0, jquery_1.default)(event.currentTarget).hasClass("is-active")) {
                var index = (0, jquery_1.default)(event.currentTarget).parent("li").index();
                (0, jquery_1.default)(".js-tglBtn").removeClass("is-active");
                (0, jquery_1.default)(".js-tglBtn").eq(index).addClass("is-active");
                (0, jquery_1.default)(".lp-tglItem").hide();
                (0, jquery_1.default)(".lp-tglItem").eq(index).stop().fadeIn(300);
                return false;
            }
        });
    },
    loaded: function () {
        (0, jquery_1.default)(".lp-fixedBtn").delay(200).animate({ opacity: 1 }, 500);
    },
    scroll: function () {
        var target = home.fixedBtn;
        var targetOffset = target.offset();
        var fixedBtnHeight = home.fixedBtn.height();
        if (targetOffset !== undefined && fixedBtnHeight !== undefined) {
            if (win.st() + win.h() > targetOffset.top + fixedBtnHeight) {
                home.fixedBtn.children(".lp-fixedBtn__inner").addClass("is-absolute");
            }
            else {
                home.fixedBtn.children(".lp-fixedBtn__inner").removeClass("is-absolute");
            }
        }
    },
    resize: function () {
        var wrapperWidth = (0, jquery_1.default)(".lp-wrapper").width();
        if (wrapperWidth !== undefined) {
            (0, jquery_1.default)(".lp-fixedBtn").css({
                width: win.w(),
                marginRight: (wrapperWidth - win.w()) * 0.5,
                marginLeft: (wrapperWidth - win.w()) * 0.5,
            });
        }
    },
};
